var exports = {
  "Rc": "RepositoryPropertyIncludeIcon__JBUPLM",
  "VT": "RepositoryPropertyExcludeIcon__1v3Oqn",
  "ME": "RepositoryPropertyLanguageWarning__BGvfoB",
};

module.exports = exports;
